import React, { Component } from "react";

import { Margin } from "styled-components-spacing";
import Center from "react-center";
import { DownOutlined, PlusOutlined } from "@ant-design/icons";

// CSS Files
import "../../Fonts/Fonts.css";
import "../../Statics/Common/FontStyle.css";
import "../../Statics/Responsibility/Responsibility.css";

const cardImage = {
  marginTop: "30px",
  width: "175px",
  height: "175px",
  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
  border: "2px solid #8d8d8d",
  borderRadius: "50%",
};
const cardImageTablet = {
  marginTop: "30px",
  width: "150px",
  height: "150px",
  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
  border: "2px solid #8d8d8d",
  borderRadius: "50%",
};
const cardImageMobile = {
  marginTop: "30px",
  width: "150px",
  height: "150px",
  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
  border: "2px solid #8d8d8d",
  borderRadius: "50%",
};

const cardTitle = {
  fontFamily: "IranSans",
  fontSize: "1em",
  color: "#186491",
};
const cardTitleTablet = {
  fontFamily: "IranSans",
  fontSize: ".9em",
  color: "#186491",
};
const cardTitleMobile = {
  fontFamily: "IranSans",
  fontSize: ".85em",
  color: "#186491",
};
const cardSentence = {
  fontFamily: "IranSans",
  fontSize: ".8em",
  color: "#8d8d8d",
  direction: "rtl",
  textAlign: "center",
  padding: "20px",
  height:"75px"
};
const cardSentenceTablet = {
  fontFamily: "IranSans",
  fontSize: ".75em",
  color: "#8d8d8d",
  direction: "rtl",
  textAlign: "center",
  padding: "20px",
};
const cardSentenceMobile = {
  fontFamily: "IranSans",
  fontSize: ".7em",
  color: "#8d8d8d",
  direction: "rtl",
  textAlign: "center",
  padding: "20px",
};

const ResponsibilityCard = (props) => {
  return props.size === "laptopdesktop" ? (
    <div>
      <div
        style={{
          borderRadius: "20px",
          backgroundColor: "#fff",
          boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
          margin: "10px",
        }}
      >
        <Center>
          <img style={cardImage} src={props.image} />
        </Center>
        <Margin top={2}></Margin>
        <Center>
          <p style={cardTitle}>
            <strong>{props.title}</strong>
          </p>
        </Center>
        <div
          style={{
            backgroundColor: "#f3f3f3",
            borderBottomLeftRadius: "20px",
            borderBottomRightRadius: "20px",
          }}
        >
          <Center>
            <p style={cardSentence}>{props.sentence}</p>
          </Center>
        </div>
      </div>
      <a
        onClick={() => props.history.push(`/responsibilityinside/${props.id}`)}
      >
        <Center>
          <div class="circleDotCard">
            <Center>
              <PlusOutlined style={{ paddingTop: "10px", color: "#ed1c24" }} />
            </Center>
          </div>
        </Center>
      </a>
    </div>
  ) : props.size === "tablet" ? (
      <div>
        <div
          style={{
            borderRadius: "20px",
            backgroundColor: "#fff",
            boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
            margin: "10px",
          }}
        >
          <Center>
            <img style={cardImageTablet} src={props.image} />
          </Center>
          <Margin top={2}></Margin>
          <Center>
            <p style={cardTitleTablet}>
              <strong>{props.title}</strong>
            </p>
          </Center>
          <div
            style={{
              backgroundColor: "#f3f3f3",
              borderBottomLeftRadius: "20px",
              borderBottomRightRadius: "20px",
            }}
          >
            <Center>
              <p style={cardSentenceTablet}>{props.sentence}</p>
            </Center>
          </div>
        </div>
        <a
          onClick={() => props.history.push(`/responsibilityinside/${props.id}`)}
        >
          <Center>
            <div class="circleDotCard">
              <Center>
                <PlusOutlined style={{ paddingTop: "10px", color: "#ed1c24" }} />
              </Center>
            </div>
          </Center>
        </a>
      </div>
  ) : (
    <div>
          <div
            style={{
              borderRadius: "20px",
              backgroundColor: "#fff",
              boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
              margin: "10px",
            }}
          >
            <Center>
              <img style={cardImageMobile} src={props.image} />
            </Center>
            <Margin top={2}></Margin>
            <Center>
              <p style={cardTitleMobile}>
                <strong>{props.title}</strong>
              </p>
            </Center>
            <div
              style={{
                backgroundColor: "#f3f3f3",
                borderBottomLeftRadius: "20px",
                borderBottomRightRadius: "20px",
              }}
            >
              <Center>
                <p style={cardSentenceMobile}>{props.sentence}</p>
              </Center>
            </div>
          </div>
          <a
            onClick={() => props.history.push(`/responsibilityinside/${props.id}`)}
          >
            <Center>
              <div class="circleDotCard">
                <Center>
                  <PlusOutlined style={{ paddingTop: "10px", color: "#ed1c24" }} />
                </Center>
              </div>
            </Center>
          </a>
    </div>
  );
};

export default ResponsibilityCard;
